import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { htcmdService } from 'js/services/htcmd.service';
import { updateDeviceAction } from 'js/hooks/device/store/actions';

const DEVICE_ID_LOCAL_STORAGE_KEY = 'hub2_device_uuid';

export const useDeviceIdFromNative = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        if (htcmdService.isEnabled) {

            htcmdService.sendDeviceIdCommand();

            window.AuthenticationHandler = {
                AuthenticationDeviceID: (deviceId) => {
                    if (!deviceId) {
                        return;
                    }

                    localStorage.setItem(DEVICE_ID_LOCAL_STORAGE_KEY, deviceId);
                    dispatch(updateDeviceAction({ deviceId }));
                }
            };
        }
    }, [dispatch]);
};
